// src/components/Toast.jsx
import React, { useEffect, useState } from "react";
import { X, AlertCircle, CheckCircle, Info } from "lucide-react";

export const useToast = () => {
  const [toasts, setToasts] = useState([]);

  const showToast = (message, type = "info", duration = 3000) => {
    const id = Date.now();
    const newToast = { id, message, type };

    setToasts((prev) => [...prev, newToast]);

    setTimeout(() => {
      setToasts((prev) => prev.filter((toast) => toast.id !== id));
    }, duration);
  };

  return { toasts, showToast };
};

export const ToastContainer = ({ toasts }) => {
  const getIcon = (type) => {
    switch (type) {
      case "success":
        return <CheckCircle className="w-5 h-5" />;
      case "error":
        return <AlertCircle className="w-5 h-5" />;
      default:
        return <Info className="w-5 h-5" />;
    }
  };

  const getStyles = (type) => {
    switch (type) {
      case "success":
        return "bg-green-500";
      case "error":
        return "bg-red-500";
      default:
        return "bg-blue-500";
    }
  };

  return (
    <div className="fixed top-4 right-4 z-50 space-y-2">
      {toasts.map((toast) => (
        <div
          key={toast.id}
          className="animate-slide-in bg-gray-900 text-white rounded-lg shadow-lg p-4 min-w-[300px] max-w-md"
        >
          <div className="flex items-center gap-3">
            <div className={`${getStyles(toast.type)} p-2 rounded`}>
              {getIcon(toast.type)}
            </div>
            <p className="flex-1">{toast.message}</p>
          </div>
        </div>
      ))}
    </div>
  );
};
